<template>
    <div :data-overlay="navOverlayBanner">
        <component
            :is="bannerComponent"
            v-if="!hideBanner"
            :nav-overlay-banner="navOverlayBanner"
        />
    </div>
</template>

<script setup>
    const { digistormSettings, appId, getGlobalSetField } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    const primaryNavSettings = computed(() => {
        return first(getGlobalSetField.value('ds_Navigation_GlobalSet', 'primaryNav'))
    })

    const navOverlayBanner = computed(() => {
        if (hideBanner.value) {
            return false
        }

        return !primaryNavSettings.value?.primaryNav_ShowBackground
    })

    const bannerType = computed(() => {
        return digistormSettings.value.bannerType
    })

    const hideBanner = computed(() => {
        return get(entry.value, 'hideBanner', false)
    })

    // check for any custom headers
    const customComponents = await import(`~/custom/${appId.value}/index.js`)
        .catch(() => {
            return null
        })


    const bannerComponent = computed(() => {
        if (bannerType.value === 'banner-custom') {
            return customComponents?.default?.HomeBanner
        }

        return defineAsyncComponent(() =>
            import(`./home/${bannerType.value}/banner.async.vue`)
        )
    })

</script>
